import React from "react";
import { Link } from "react-router-dom";
import FoundryConnectLogo from "@via/components/foundry-connect-logo.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { ClockIcon } from "@heroicons/react/24/outline";

interface PendingApprovalScreenProps {
  organizationName: string;
}

const PendingApprovalScreen: React.FC<PendingApprovalScreenProps> = ({
  organizationName,
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-md p-8 text-center">
      <FoundryConnectLogo />
      <div className="mt-10 flex justify-center">
        <ClockIcon className="h-16 w-16 text-amber-500" aria-hidden="true" />
      </div>
      <h1 className="mt-6 text-2xl font-bold text-gray-900">
        Registration Pending
      </h1>
      <p className="mt-4 text-gray-600">
        Thank you for signing up. Your request to join{" "}
        <span className="font-semibold">{organizationName}</span> is pending
        admin approval.
      </p>
      <p className="mt-2 text-gray-600">
        You will receive an email once approved. Until then, you cannot log in.
      </p>
      <Link
        to={ROUTES.LOGIN}
        className="mt-8 text-sm font-semibold text-indigo-600 hover:text-indigo-500">
        Go to Login
      </Link>
    </div>
  );
};

export default PendingApprovalScreen;
